import { render } from "./PhotoGalleryOverlay.vue?vue&type=template&id=7f4c2561&scoped=true"
import script from "./PhotoGalleryOverlay.vue?vue&type=script&lang=js"
export * from "./PhotoGalleryOverlay.vue?vue&type=script&lang=js"

import "./PhotoGalleryOverlay.vue?vue&type=style&index=0&id=7f4c2561&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f4c2561"]])

export default __exports__